export default {"src":"/_next/static/media/rocket.493a1d87.svg","height":88,"width":94,"blurWidth":0,"blurHeight":0};